export default __webpack_public_path__ + "static/media/mockup-presentation.de9828b7.png";